import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    FilterContainer: {
        display: 'flex'
    },
    FilterButton: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
    },
    FilterIcon: {
        fontSize: '16px !important'
    },
    ClearFiltersIconButton: {
        borderRadius: '4px',
        border: '1px solid #0000003B',
        fontSize: '16px',
        width: '38px',
        borderLeft: 'none',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
    },
    PopoverCard: {
        width: '574px',
        marginTop: '4px'
    },
    FilterRow: {
        display: 'flex',
        alignItems: 'center'
    },
    CardActionsSection: {
        borderTop: '1px solid #0000001F'
    },
    FilterSwitch: {
        marginLeft: '-10px'
    }
}));
//# sourceMappingURL=styles.js.map